import { StaticBaseDao } from '@/dao';
import { IntArray, StationDetails } from '@/objects/generated';

export class StationDetailsDao extends StaticBaseDao {
    public static async GetStationDetails(EventID: number, ids: IntArray): Promise<StationDetails[]> {
        return this.BaseFetchArray(
            StationDetails,
            `StationDetails/GetStationDetails` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            ids,
        );
    }
}
